import { useSso } from '@/utils/providers/SSOProvider';
import cn from 'classnames';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { PathProps } from './UniversalSidebar';

interface SidebarItemProps extends PathProps {
    isExpanded: boolean;
    neutral?: boolean;
}

export function SidebarItem({
    Icon,
    label,
    isExpanded,
    neutral = false,
    permissions = [],
    path,
    onClick
}: SidebarItemProps) {
    const navigate = useNavigate();

    const { hasPermission } = useSso();

    const isAuthorized = useMemo(() => {
        if (permissions.length === 0) return true;
        return hasPermission(permissions, 'all');
    }, [hasPermission, permissions]);
    const pathname = location.pathname.replace(/\/$/, '');

    return (
        <div
            onClick={() => {
                if (onClick) onClick();
                else if (isAuthorized) navigate(path);
            }}
            className={cn('w-full flex items-center py-3 rounded-md transition-colors duration-50', {
                ['cursor-pointer']: isAuthorized,
                ['bg-brand-primary text-brand-text']: isAuthorized && pathname === path && !neutral,
                ['hover:bg-brand-neutral-700']: isAuthorized && pathname !== path && !neutral,
                ['bg-transparent text-brand-neutral-400']: isAuthorized && pathname === path && neutral,
                ['hover:bg-brand-neutral-700 hover:text-brand-text']: isAuthorized && pathname !== path && neutral,
                ['cursor-not-allowed text-brand-neutral-500']: !isAuthorized,
                ['px-4 gap-3']: isExpanded,
                ['justify-center']: !isExpanded
            })}>
            <Icon className="w-5 h-5 flex-shrink-0" />
            <span
                className={cn(`whitespace-nowrap overflow-hidden transition-all duration-200`, {
                    ['opacity-100 w-auto']: isExpanded,
                    ['opacity-0 w-0']: !isExpanded
                })}>
                {label}
            </span>
        </div>
    );
}
